import { createPortal } from "react-dom";
import { useTradeFooterPortal } from "@/components/features/trade/MobileTradeModal/TradeFooterPortalContext";
import { cn } from "@/lib/utils";

export type MainFooterProps = {
  className?: string;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const MainFooter = ({ children, className, ...divProps }: MainFooterProps) => {
  const portalTarget = useTradeFooterPortal();

  const footer = (
    <div className={cn("w-full flex flex-col items-stretch gap-6", className)} {...divProps}>
      {children}
    </div>
  );

  if (portalTarget) {
    return createPortal(footer, portalTarget);
  }

  return footer;
};
